const KEY = "doh_recently_viewed";
const MAX = 30;

export function getRecentlyViewed() {
  try {
    return JSON.parse(localStorage.getItem(KEY) || "[]");
  } catch {
    return [];
  }
}

export function saveRecentlyViewed(ins) {
  if (!ins || !ins.id) return;
  try {
    const list = getRecentlyViewed().filter((x) => x.id !== ins.id);
    list.unshift({ ...ins, _viewed_at: Date.now() });
    localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
  } catch {
    /* storage unavailable — ignore */
  }
}

export function getCachedInsulator(id) {
  return getRecentlyViewed().find((x) => String(x.id) === String(id)) || null;
}
